(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["thj-favor-gallery-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStrips() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    var cards = document.querySelectorAll('.thj-fg--carousel .thj-fg__item');
    if (!cards.length) return;
    var io = new IntersectionObserver(function (obs) {
      obs.forEach(function (o) {
        if (o.isIntersecting) { o.target.classList.add('thj-anim--in'); io.unobserve(o.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    cards.forEach(function (t, idx) {
      if (t.classList.contains('thj-anim')) return;
      t.classList.add('thj-anim');
      t.style.transitionDelay = (idx % 6) * 60 + 'ms';
      io.observe(t);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStrips);
  } else {
    initStrips();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thj-favor-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  var lbItems = [], lbIndex = 0;

  function ensureLightbox() {
    var dlg = document.getElementById('thj-lightbox');
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'thj-lightbox';
    dlg.id = 'thj-lightbox';
    dlg.setAttribute('aria-label', 'Photo viewer');
    dlg.innerHTML =
      '<button type="button" class="thj-lightbox__close" data-thj-lightbox-close aria-label="Close photo viewer">✕</button>' +
      '<button type="button" class="thj-lightbox__nav thj-lightbox__nav--prev" data-thj-lightbox-prev aria-label="Previous photo">‹</button>' +
      '<figure><img src="" alt="" id="thj-lightbox-img"><a class="thj-lightbox__more" id="thj-lightbox-more" href="" hidden><span></span></a><figcaption id="thj-lightbox-caption" aria-live="polite"></figcaption></figure>' +
      '<button type="button" class="thj-lightbox__nav thj-lightbox__nav--next" data-thj-lightbox-next aria-label="Next photo">›</button>';
    document.body.appendChild(dlg);

    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });
    var touchX = null;
    dlg.addEventListener('touchstart', function (e) { touchX = e.changedTouches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
      touchX = null;
    }, { passive: true });
    return dlg;
  }

  function renderCurrent() {
    var img = document.getElementById('thj-lightbox-img');
    var cap = document.getElementById('thj-lightbox-caption');
    var more = document.getElementById('thj-lightbox-more');
    var btn = lbItems[lbIndex];
    if (!btn) return;
    img.src = btn.dataset.full;
    if (btn.hasAttribute('data-thj-more')) {
      img.alt = '';
      cap.textContent = '';
      more.href = btn.href;
      more.querySelector('span').textContent = btn.dataset.moreText || 'View more';
      more.hidden = false;
    } else {
      img.alt = (btn.getAttribute('aria-label') || '').replace(/^Enlarge photo: /, '');
      cap.textContent = btn.dataset.caption || '';
      more.hidden = true;
    }
    var prev = document.querySelector('.thj-lightbox__nav--prev');
    var next = document.querySelector('.thj-lightbox__nav--next');
    if (prev) prev.hidden = lbIndex === 0 || lbItems.length < 2;
    if (next) next.hidden = lbIndex === lbItems.length - 1 || lbItems.length < 2;
  }

  function step(dir) {
    var target = lbIndex + dir;
    if (target < 0 || target >= lbItems.length) return;
    lbIndex = target;
    renderCurrent();
  }

  function openLightbox(btn) {
    var dlg = ensureLightbox();
    if (typeof dlg.showModal !== 'function') return;
    var list = btn.closest('ul');
    lbItems = list
      ? Array.prototype.filter.call(list.querySelectorAll('[data-thj-lightbox]'), function (b) {
          var li = b.closest('li');
          return !(li && li.hidden);
        })
      : [btn];
    if (list) {
      var moreCard = list.querySelector('a[data-thj-more]');
      if (moreCard) lbItems.push(moreCard);
    }
    lbIndex = lbItems.indexOf(btn);
    if (lbIndex < 0) lbIndex = 0;
    renderCurrent();
    dlg.showModal();
  }

  function init() {
    var state = { occasion: '', format: '' };
    function apply() {
      var items = document.querySelectorAll('#thj-fg-list-page .thj-fg__item');
      var count = document.getElementById('thj-fg-count');
      var visible = 0;
      items.forEach(function (it) {
        var ok = (!state.occasion || it.dataset.occasion === state.occasion) &&
                 (!state.format || it.dataset.format === state.format);
        it.hidden = !ok;
        if (ok) visible++;
      });
      if (count) count.textContent = visible + ' photos shown';
    }
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-thj-filter]');
      if (chip) {
        var group = chip.dataset.group;
        state[group] = chip.dataset.value;
        document.querySelectorAll('[data-thj-filter]').forEach(function (c) {
          if (c.dataset.group === group) c.setAttribute('aria-pressed', String(c === chip));
        });
        apply();
        return;
      }
      var sc = e.target.closest('[data-thj-scroll]');
      if (sc) {
        var wrap = sc.closest('.thj-fg-scroller');
        var list = wrap && wrap.querySelector('ul.thj-fg--carousel');
        if (list) {
          var amt = Math.round(list.clientWidth * 0.8);
          list.scrollBy({ left: sc.dataset.thjScroll === 'next' ? amt : -amt, behavior: 'smooth' });
        }
        return;
      }
      var btn = e.target.closest('[data-thj-lightbox]');
      if (btn) { openLightbox(btn); return; }
      if (e.target.closest('[data-thj-lightbox-prev]')) { step(-1); return; }
      if (e.target.closest('[data-thj-lightbox-next]')) { step(1); return; }
      var dlg = document.getElementById('thj-lightbox');
      if (e.target.closest('[data-thj-lightbox-close]')) { if (dlg) dlg.close(); return; }
      if (dlg && e.target === dlg) dlg.close();
    });

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('#thj-fg-list-page .thj-fg__item, .thj-fg-ctas, .thj-fg-submit');
    if (!targets.length) return;
    var io = new IntersectionObserver(function (obs) {
      obs.forEach(function (o) {
        if (o.isIntersecting) { o.target.classList.add('thj-anim--in'); io.unobserve(o.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (t, idx) {
      t.classList.add('thj-anim');
      t.style.transitionDelay = (idx % 4) * 60 + 'ms';
      io.observe(t);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thj-favors-start-here"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var secs = (root || document).querySelectorAll('.thj-favors');
    secs.forEach(function (s) {
      if (s.dataset.thjInit) return;
      s.dataset.thjInit = '1';
      s.classList.add('thj-js');
      if (!('IntersectionObserver' in window)) { s.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { s.classList.add('is-in'); io.disconnect(); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      io.observe(s);
    });
  }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', function () { init(); }); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
